// extracted by mini-css-extract-plugin
module.exports = {"cardReaderCircle":"CardReaderCircle_cardReaderCircle__8romk","outerCircle":"CardReaderCircle_outerCircle__33_81","innerCircle":"CardReaderCircle_innerCircle__3-K5t"};